import { useMemo } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../shadcn/Select";

const Page = ({ numPages = 0, value = 1, onChange }) => {
  const pagesList = useMemo(() => {
    const pagesArray = [];
    for (let i = 1; i <= Math.max(1, numPages); i++) {
      pagesArray.push(i);
    }
    return pagesArray;
  }, [numPages]);

  // Ensure value is valid
  const currentValue = Math.max(1, Math.min(value || 1, numPages || 1));

  return (
    <Select
      value={String(currentValue)}
      onValueChange={(newValue) => onChange(Number(newValue))}
      disabled={numPages <= 1}
    >
      <SelectTrigger>
        <SelectValue placeholder="Page">
          {numPages > 0 ? `Page ${currentValue}/${numPages}` : "Page 1"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {pagesList.map((page) => (
          <SelectItem key={page} value={String(page)}>
            {page}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default Page;
